import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { newsList } from "@/mocks/news";
import Breadcrumb from "@/components/base/Breadcrumb";
import Pagination from "@/components/base/Pagination";
import NewsCard from "@/components/feature/NewsCard";

const PAGE_SIZE = 6;

export default function NewsPage() {
  const [page, setPage] = useState(1);

  const sorted = useMemo(() => [...newsList].sort((a, b) => b.date.localeCompare(a.date)), []);
  const totalPages = Math.max(1, Math.ceil(sorted.length / PAGE_SIZE));
  const currentPage = Math.min(page, totalPages);
  const paged = sorted.slice((currentPage - 1) * PAGE_SIZE, currentPage * PAGE_SIZE);

  return (
    <div className="pt-24 md:pt-28">
      <div className="bg-background-100 border-b border-background-200">
        <div className="max-w-7xl mx-auto w-full px-4 md:px-8 py-8 md:py-12">
          <Breadcrumb items={[{ label: "首页", to: "/" }, { label: "资讯列表" }]} />
          <h1 className="mt-5 font-heading text-2xl md:text-4xl font-semibold text-foreground-950">
            叶山小百合资讯动态
          </h1>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-3xl leading-relaxed">
            汇总叶山小百合的定档消息、开机拍摄、奖项提名、媒体专访与幕后花絮，第一时间了解她的影视动态。
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto w-full px-4 md:px-8 py-10 md:py-14">
        {paged.length > 0 ? (
          <>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
              {paged.map((item) => (
                <NewsCard key={item.id} item={item} />
              ))}
            </div>
            <div className="mt-12">
              <Pagination current={currentPage} total={totalPages} onChange={setPage} />
            </div>
          </>
        ) : (
          <div className="flex flex-col items-center justify-center py-20 text-center">
            <span className="w-16 h-16 rounded-full bg-background-100 text-foreground-400 flex items-center justify-center mb-5">
              <i className="ri-newspaper-line text-3xl"></i>
            </span>
            <h3 className="font-heading text-lg font-semibold text-foreground-900">暂无最新资讯</h3>
            <p className="mt-2 text-sm text-foreground-500">暂时没有可展示的资讯内容。</p>
            <Link
              to="/"
              className="mt-6 inline-flex items-center gap-2 px-5 h-11 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-home-4-line"></i>
              </span>
              返回首页
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}